import React from 'react';
import block from 'bem-cn-lite';
import { TransitionGroup } from 'react-transition-group';
import { FadeTransition } from '../Transitions';

class InfoTooltip extends React.Component {
    render() {
        const { text } = this.props;

        const b = block('InfoTooltip')

        return (
            <TransitionGroup 
                component="div"
                className={b()}
            >
                {text &&
                    <FadeTransition>
                        <div className={b('content')}>
                            {text}
                        </div>
                    </FadeTransition>
                }
            </TransitionGroup>
        )
    }
}

export default InfoTooltip;